// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Product Contact Section Styles */
.scl--web-page-product-contact-section-box{
    width: 100%;
    background: #000000;
    padding-bottom: 150px;
}
.scl--web-page-product-contact-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: var(--global-desktop-width-resp);
  margin: 0 auto;
  padding: 60px var(--global-desktop-padding-left) 60px var(--global-desktop-padding-left);
  min-height: 500px;
 
}

.scl--web-page-product-contact-section-lap{
  width: 100%;
}

/* Top area: label+title (left) + description (right) */
.scl--web-page-product-contact-top {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  padding: 100px 0 94px;
}

.scl--web-page-product-contact-top-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 74px;
  max-width: 833px;
}

/* Label with brackets */
.scl--web-page-product-contact-label {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 2px;
  gap: 11px;
}

.scl--web-page-product-contact-label-bracket-left,
.scl--web-page-product-contact-label-bracket-right {
  width: 5px;
  height: 18px;
  border: 1.5px solid #7D8187;
}

.scl--web-page-product-contact-label-bracket-left {
  border-right: none;
}

.scl--web-page-product-contact-label-bracket-right {
  border-left: none;
}

.scl--web-page-product-contact-label-text {
  font-family: var(--primary-font);
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: #7D8187;
}

/* Title */
.scl--web-page-product-contact-title {
  font-family: var(--primary-font);
  font-weight: 510;
  font-size: 70px;
  line-height: 72px;
  letter-spacing: -1.68px;
  color: #FFFFFF;
  margin: 0;
}

/* Description (right side) */
.scl--web-page-product-contact-description {
  font-family: var(--primary-font);
  font-weight: 274;
  font-size: 20px;
  line-height: 30px;
  padding-right: 40px;
  color: #969EAA;
  max-width: 577px;
  padding-left: 60px;
  margin: 0;
  padding-top: 120px;
}

/* Cards row */
.scl--web-page-product-contact-cards {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
  max-width: 1439px;
}

/* Card wrapper with border separators */
.scl--web-page-product-contact-card-wrapper {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px 60px 20px 50px;
  min-height: 369px;
  flex: 1;
  border-right: 1px solid rgba(255, 255, 255, 0.2);
}

.scl--web-page-product-contact-card-wrapper:first-child {
  border-left: 1px solid rgba(255, 255, 255, 0.2);
}

/* Grid layout for 3+ cards - 2 items per row */
.scl--web-page-product-contact-cards-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 40px 0;
}

.scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper {
  flex: 0 0 50%;
  max-width: 50%;
  border-right: 1px solid rgba(255, 255, 255, 0.2);
  border-left: none;
}

.scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper:nth-child(odd) {
  border-left: 1px solid rgba(255, 255, 255, 0.2);
}

.scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper:nth-child(even) {
  border-right: 1px solid rgba(255, 255, 255, 0.2);
}

/* Single item in last row - full width and centered */
.scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper:last-child:nth-child(odd) {
  flex: 0 0 100%;
  max-width: 100%;
  border-right: 1px solid rgba(255, 255, 255, 0.2);
  align-items: center;
  text-align: center;
}

.scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper:last-child:nth-child(odd) .scl--web-component-dynamic-contact-card {
  align-items: center;
}

.scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper:last-child:nth-child(odd) .scl--web-component-dynamic-contact-card-icon {
  display: flex;
  justify-content: center;
}

.scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper:last-child:nth-child(odd) .scl--web-component-dynamic-contact-card-content {
  align-items: center;
  text-align: center;
}

.scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper:last-child:nth-child(odd) .scl--web-component-dynamic-contact-card-title,
.scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper:last-child:nth-child(odd) .scl--web-component-dynamic-contact-card-description {
  text-align: center;
}

/* Responsive Design */

@media screen and (max-width: 1728px) {
  .scl--web-page-product-contact-section {
    padding: 0 var(--global-laptop-padding-left);
  }

  .scl--web-page-product-contact-description{
    padding-left: 80px;
  }
}

@media screen and (max-width: 1440px) {
  .scl--web-page-product-contact-section {
    padding: 60px var(--global-laptop-padding-left);
  }

  .scl--web-page-product-contact-section-container {
    padding-right: 20px;
  }

  .scl--web-page-product-contact-top {
    padding: 80px 0 70px;
  }

  .scl--web-page-product-contact-top-left {
    gap: 50px;
    max-width: 600px;
  }

  .scl--web-page-product-contact-description {
    max-width: 450px;
    padding-left: 40px;
    padding-top: 80px;
  }

  .scl--web-page-product-contact-cards {
    max-width: 100%;
  }

  .scl--web-page-product-contact-card-wrapper {
    padding: 20px 40px 20px 30px;
    min-height: 320px;
  }
}

@media screen and (max-width: 1280px) {
  .scl--web-page-product-contact-section {
    padding: 60px var(--global-laptop-padding-left);
    height: auto;
  }

  .scl--web-page-product-contact-top {
    flex-direction: column;
    gap: 30px;
    padding: 60px 0 50px;
  }

  .scl--web-page-product-contact-top-left {
    gap: 40px;
    max-width: 100%;
  }

  .scl--web-page-product-contact-description {
    padding-left: 0;
    padding-top: 0;
    max-width: 100%;
  }

  /* Cards - Portrait/Column layout */
  .scl--web-page-product-contact-cards {
    flex-direction: column;
    gap: 80px;
    width: 100%;
  }

  /* Override grid layout at 1280px - stack vertically */
  .scl--web-page-product-contact-cards-grid {
    flex-direction: column;
    gap: 80px;
  }

  .scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper {
    flex: none;
    max-width: 100%;
    width: 100%;
    border-right: none;
    border: none;
  }

  .scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper:nth-child(odd),
  .scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper:nth-child(even) {
    border-right: none;
    border-left: none;
  }

  .scl--web-page-product-contact-card-wrapper {
    width: 100%;
    flex: none;
    border-right: none;
    border-left: 1px solid rgba(255, 255, 255, 0.2);
    padding: 20px 0px 50px;
    min-height: auto;
  }

    .scl--web-page-product-contact-card-wrapper:first-child {
    border: none;
  }

  .scl--web-page-product-contact-card-wrapper:last-child {
    border: none;
  }

  .scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper:nth-child(even) {
    border: none;
  }
  .scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper:last-child:nth-child(odd) {
    border: none;
    align-items: flex-start;
    text-align: left;
  }

  .scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper:last-child:nth-child(odd) .scl--web-component-dynamic-contact-card {
    align-items: flex-start;
  }

  .scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper:last-child:nth-child(odd) .scl--web-component-dynamic-contact-card-icon {
    justify-content: flex-start;
  }

  .scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper:last-child:nth-child(odd) .scl--web-component-dynamic-contact-card-content {
    align-items: flex-start;
    text-align: left;
  }

  .scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper:last-child:nth-child(odd) .scl--web-component-dynamic-contact-card-title,
  .scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper:last-child:nth-child(odd) .scl--web-component-dynamic-contact-card-description {
    text-align: left;
  }

}

@media screen and (max-width: 850px) {
  .scl--web-page-product-contact-section {
    padding: 0 var(--global-tablet-padding-left) 50px var(--global-tablet-padding-left);
    height: auto;
    max-height: none;
  }
  .scl--web-page-product-contact-section-container{
    padding: 0px;
  }

  .scl--web-page-product-contact-card-wrapper .scl--web-component-dynamic-contact-card-description{
    line-height: 30px;
  }

  .scl--web-page-product-contact-top {
    flex-direction: column;
    gap: 30px;
    padding: 90px 0px;
  }

  .scl--web-page-product-contact-top-left {
    gap: 60px;
    max-width: 771px;
  }

  .scl--web-page-product-contact-title {
    font-size: 70px;
    line-height: 85px;
    letter-spacing: -1.68px;
  }

  .scl--web-page-product-contact-description {
    padding: 0;
    max-width: 771px;
    font-size: 28px;
    line-height: 30px;
  }

  .scl--web-page-product-contact-cards {
    flex-direction: column;
    gap: 100px;
    width: 100%;
    margin: 0 auto;
  }

  .scl--web-page-product-contact-card-wrapper {
    width: 100%;
    flex: none;
    border: none;
    border-top: none;
    border-bottom: none;
    padding: 0px;
    min-height: 369px;
    gap: 83px;
  }

  .scl--web-page-product-contact-card-wrapper:first-child {
    border: none;
  }

  .scl--web-page-product-contact-card-wrapper:last-child {
    border-bottom: none;
  }

  /* Override grid layout at 850px */
  .scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper {
    border: none;
  }

  .scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper:nth-child(odd),
  .scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper:nth-child(even) {
    border: none;
  }

  .scl--web-page-product-contact-card-wrapper  .scl--web-component-dynamic-contact-card-title{
    font-size: 40px;
  }
    .scl--web-page-product-contact-card-wrapper  .scl--web-component-dynamic-contact-card-description{
    font-size: 28px;
  }
  .scl--web-page-product-contact-card-wrapper .scl--web-component-dynamic-contact-card-button .scl--web-component-round-button-text{
    font-size: 28px;

  }
  .scl--web-page-product-contact-card-wrapper .scl--web-component-dynamic-contact-card-button{
    width: 380px;
    height: 60px;
    border-radius: 30px;
  }

  

}

@media screen and (max-width: 500px) {
  .scl--web-page-product-contact-section {
    padding-left: var(--global-mobile-padding-left);
    padding-right: var(--global-mobile-padding-right);
    height: auto;
    max-height: none;
    margin-top: 50px;
  }

  .scl--web-page-product-contact-top {
    padding: 40px 0px;
    gap: 20px;
  }

  .scl--web-page-product-contact-top-left {
    gap: 74px;
    max-width: 388px;
  }

  .scl--web-page-product-contact-title {
    font-size: 60px;
    line-height: 60px;
    letter-spacing: -1.68px;
  }

  .scl--web-page-product-contact-description {
    font-size: 24px;
    line-height: 40px;
    max-width: 411px;
  }

  .scl--web-page-product-contact-card-wrapper .scl--web-component-dynamic-contact-card-content {
    width: 100%;
    padding: 0 0;
    gap: 40px;
  }

  .scl--web-page-product-contact-cards {
    gap: 55px;
  }

  .scl--web-page-product-contact-card-wrapper {
    border-left: none;
    border-right: none;
    padding: 20px 0px;
    gap: 83px;
    min-height: auto;
  }

  .scl--web-page-product-contact-card-wrapper:first-child {
    border-left: none;
  }

  .scl--web-page-product-contact-card-wrapper .scl--web-component-dynamic-contact-card-title {
    font-size: 55px;
  }

  .scl--web-page-product-contact-card-wrapper .scl--web-component-dynamic-contact-card-description {
    font-size: 24px;
    line-height: 150%;
  }
  .scl--web-page-product-contact-card-wrapper:last-child{
    padding: 0;
  }

  /* Override grid layout at 500px */
  .scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper {
    border-left: none;
    border-right: none;
  }

  .scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper:nth-child(odd),
  .scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper:nth-child(even) {
    border-left: none;
    border-right: none;
  }
    .scl--web-page-product-contact-card-wrapper .scl--web-component-dynamic-contact-card-button .scl--web-component-round-button-text{
    font-size: 24px;

  }
  .scl--web-page-product-contact-card-wrapper .scl--web-component-dynamic-contact-card-button{
    width: 100%;
    height: 50px;
    border-radius: 25px;
  }

  .scl--web-page-product-contact-section .scl--web-page-product-contact-section-lap{
    width: 100%;
  }

}
`, "",{"version":3,"sources":["webpack://./src/page-module/page-services/product/css/productContact.css"],"names":[],"mappings":"AAAA,mCAAmC;AACnC;IACI,WAAW;IACX,mBAAmB;IACnB,qBAAqB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2CAA2C;EAC3C,cAAc;EACd,wFAAwF;EACxF,iBAAiB;;AAEnB;;AAEA;EACE,WAAW;AACb;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,SAAS;AACX;;AAEA;;EAEE,UAAU;EACV,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,SAAS;AACX;;AAEA,6BAA6B;AAC7B;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,WAAW;EACX,iBAAiB;AACnB;;AAEA,wCAAwC;AACxC;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,iBAAiB;EACjB,OAAO;EACP,gDAAgD;AAClD;;AAEA;EACE,+CAA+C;AACjD;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gDAAgD;EAChD,iBAAiB;AACnB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,gDAAgD;AAClD;;AAEA,sDAAsD;AACtD;EACE,cAAc;EACd,eAAe;EACf,gDAAgD;EAChD,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA,sBAAsB;;AAEtB;EACE;IACE,4CAA4C;EAC9C;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,+CAA+C;EACjD;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,4BAA4B;IAC5B,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,+CAA+C;IAC/C,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,eAAe;EACjB;;EAEA,mCAAmC;EACnC;IACE,sBAAsB;IACtB,SAAS;IACT,WAAW;EACb;;EAEA,sDAAsD;EACtD;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,UAAU;IACV,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,YAAY;EACd;;EAEA;;IAEE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,+CAA+C;IAC/C,sBAAsB;IACtB,gBAAgB;EAClB;;IAEE;IACA,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;EACA;IACE,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;;IAEE,gBAAgB;EAClB;;AAEF;;AAEA;EACE;IACE,mFAAmF;IACnF,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,UAAU;IACV,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA,kCAAkC;EAClC;IACE,YAAY;EACd;;EAEA;;IAEE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;IACE;IACA,eAAe;EACjB;EACA;IACE,eAAe;;EAEjB;EACA;IACE,YAAY;IACZ,YAAY;IACZ,mBAAmB;EACrB;;;;AAIF;;AAEA;EACE;IACE,+CAA+C;IAC/C,iDAAiD;IACjD,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;;EAEA,kCAAkC;EAClC;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;;IAEE,iBAAiB;IACjB,kBAAkB;EACpB;IACE;IACA,eAAe;;EAEjB;EACA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;AAEF","sourcesContent":["/* Product Contact Section Styles */\n.scl--web-page-product-contact-section-box{\n    width: 100%;\n    background: #000000;\n    padding-bottom: 150px;\n}\n.scl--web-page-product-contact-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  max-width: var(--global-desktop-width-resp);\n  margin: 0 auto;\n  padding: 60px var(--global-desktop-padding-left) 60px var(--global-desktop-padding-left);\n  min-height: 500px;\n \n}\n\n.scl--web-page-product-contact-section-lap{\n  width: 100%;\n}\n\n/* Top area: label+title (left) + description (right) */\n.scl--web-page-product-contact-top {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: space-between;\n  width: 100%;\n  padding: 100px 0 94px;\n}\n\n.scl--web-page-product-contact-top-left {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 74px;\n  max-width: 833px;\n}\n\n/* Label with brackets */\n.scl--web-page-product-contact-label {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0 2px;\n  gap: 11px;\n}\n\n.scl--web-page-product-contact-label-bracket-left,\n.scl--web-page-product-contact-label-bracket-right {\n  width: 5px;\n  height: 18px;\n  border: 1.5px solid #7D8187;\n}\n\n.scl--web-page-product-contact-label-bracket-left {\n  border-right: none;\n}\n\n.scl--web-page-product-contact-label-bracket-right {\n  border-left: none;\n}\n\n.scl--web-page-product-contact-label-text {\n  font-family: var(--primary-font);\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 150%;\n  color: #7D8187;\n}\n\n/* Title */\n.scl--web-page-product-contact-title {\n  font-family: var(--primary-font);\n  font-weight: 510;\n  font-size: 70px;\n  line-height: 72px;\n  letter-spacing: -1.68px;\n  color: #FFFFFF;\n  margin: 0;\n}\n\n/* Description (right side) */\n.scl--web-page-product-contact-description {\n  font-family: var(--primary-font);\n  font-weight: 274;\n  font-size: 20px;\n  line-height: 30px;\n  padding-right: 40px;\n  color: #969EAA;\n  max-width: 577px;\n  padding-left: 60px;\n  margin: 0;\n  padding-top: 120px;\n}\n\n/* Cards row */\n.scl--web-page-product-contact-cards {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: stretch;\n  width: 100%;\n  max-width: 1439px;\n}\n\n/* Card wrapper with border separators */\n.scl--web-page-product-contact-card-wrapper {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 20px 60px 20px 50px;\n  min-height: 369px;\n  flex: 1;\n  border-right: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.scl--web-page-product-contact-card-wrapper:first-child {\n  border-left: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n/* Grid layout for 3+ cards - 2 items per row */\n.scl--web-page-product-contact-cards-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 40px 0;\n}\n\n.scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper {\n  flex: 0 0 50%;\n  max-width: 50%;\n  border-right: 1px solid rgba(255, 255, 255, 0.2);\n  border-left: none;\n}\n\n.scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper:nth-child(odd) {\n  border-left: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper:nth-child(even) {\n  border-right: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n/* Single item in last row - full width and centered */\n.scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper:last-child:nth-child(odd) {\n  flex: 0 0 100%;\n  max-width: 100%;\n  border-right: 1px solid rgba(255, 255, 255, 0.2);\n  align-items: center;\n  text-align: center;\n}\n\n.scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper:last-child:nth-child(odd) .scl--web-component-dynamic-contact-card {\n  align-items: center;\n}\n\n.scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper:last-child:nth-child(odd) .scl--web-component-dynamic-contact-card-icon {\n  display: flex;\n  justify-content: center;\n}\n\n.scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper:last-child:nth-child(odd) .scl--web-component-dynamic-contact-card-content {\n  align-items: center;\n  text-align: center;\n}\n\n.scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper:last-child:nth-child(odd) .scl--web-component-dynamic-contact-card-title,\n.scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper:last-child:nth-child(odd) .scl--web-component-dynamic-contact-card-description {\n  text-align: center;\n}\n\n/* Responsive Design */\n\n@media screen and (max-width: 1728px) {\n  .scl--web-page-product-contact-section {\n    padding: 0 var(--global-laptop-padding-left);\n  }\n\n  .scl--web-page-product-contact-description{\n    padding-left: 80px;\n  }\n}\n\n@media screen and (max-width: 1440px) {\n  .scl--web-page-product-contact-section {\n    padding: 60px var(--global-laptop-padding-left);\n  }\n\n  .scl--web-page-product-contact-section-container {\n    padding-right: 20px;\n  }\n\n  .scl--web-page-product-contact-top {\n    padding: 80px 0 70px;\n  }\n\n  .scl--web-page-product-contact-top-left {\n    gap: 50px;\n    max-width: 600px;\n  }\n\n  .scl--web-page-product-contact-description {\n    max-width: 450px;\n    padding-left: 40px;\n    padding-top: 80px;\n  }\n\n  .scl--web-page-product-contact-cards {\n    max-width: 100%;\n  }\n\n  .scl--web-page-product-contact-card-wrapper {\n    padding: 20px 40px 20px 30px;\n    min-height: 320px;\n  }\n}\n\n@media screen and (max-width: 1280px) {\n  .scl--web-page-product-contact-section {\n    padding: 60px var(--global-laptop-padding-left);\n    height: auto;\n  }\n\n  .scl--web-page-product-contact-top {\n    flex-direction: column;\n    gap: 30px;\n    padding: 60px 0 50px;\n  }\n\n  .scl--web-page-product-contact-top-left {\n    gap: 40px;\n    max-width: 100%;\n  }\n\n  .scl--web-page-product-contact-description {\n    padding-left: 0;\n    padding-top: 0;\n    max-width: 100%;\n  }\n\n  /* Cards - Portrait/Column layout */\n  .scl--web-page-product-contact-cards {\n    flex-direction: column;\n    gap: 80px;\n    width: 100%;\n  }\n\n  /* Override grid layout at 1280px - stack vertically */\n  .scl--web-page-product-contact-cards-grid {\n    flex-direction: column;\n    gap: 80px;\n  }\n\n  .scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper {\n    flex: none;\n    max-width: 100%;\n    width: 100%;\n    border-right: none;\n    border: none;\n  }\n\n  .scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper:nth-child(odd),\n  .scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper:nth-child(even) {\n    border-right: none;\n    border-left: none;\n  }\n\n  .scl--web-page-product-contact-card-wrapper {\n    width: 100%;\n    flex: none;\n    border-right: none;\n    border-left: 1px solid rgba(255, 255, 255, 0.2);\n    padding: 20px 0px 50px;\n    min-height: auto;\n  }\n\n    .scl--web-page-product-contact-card-wrapper:first-child {\n    border: none;\n  }\n\n  .scl--web-page-product-contact-card-wrapper:last-child {\n    border: none;\n  }\n\n  .scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper:nth-child(even) {\n    border: none;\n  }\n  .scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper:last-child:nth-child(odd) {\n    border: none;\n    align-items: flex-start;\n    text-align: left;\n  }\n\n  .scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper:last-child:nth-child(odd) .scl--web-component-dynamic-contact-card {\n    align-items: flex-start;\n  }\n\n  .scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper:last-child:nth-child(odd) .scl--web-component-dynamic-contact-card-icon {\n    justify-content: flex-start;\n  }\n\n  .scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper:last-child:nth-child(odd) .scl--web-component-dynamic-contact-card-content {\n    align-items: flex-start;\n    text-align: left;\n  }\n\n  .scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper:last-child:nth-child(odd) .scl--web-component-dynamic-contact-card-title,\n  .scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper:last-child:nth-child(odd) .scl--web-component-dynamic-contact-card-description {\n    text-align: left;\n  }\n\n}\n\n@media screen and (max-width: 850px) {\n  .scl--web-page-product-contact-section {\n    padding: 0 var(--global-tablet-padding-left) 50px var(--global-tablet-padding-left);\n    height: auto;\n    max-height: none;\n  }\n  .scl--web-page-product-contact-section-container{\n    padding: 0px;\n  }\n\n  .scl--web-page-product-contact-card-wrapper .scl--web-component-dynamic-contact-card-description{\n    line-height: 30px;\n  }\n\n  .scl--web-page-product-contact-top {\n    flex-direction: column;\n    gap: 30px;\n    padding: 90px 0px;\n  }\n\n  .scl--web-page-product-contact-top-left {\n    gap: 60px;\n    max-width: 771px;\n  }\n\n  .scl--web-page-product-contact-title {\n    font-size: 70px;\n    line-height: 85px;\n    letter-spacing: -1.68px;\n  }\n\n  .scl--web-page-product-contact-description {\n    padding: 0;\n    max-width: 771px;\n    font-size: 28px;\n    line-height: 30px;\n  }\n\n  .scl--web-page-product-contact-cards {\n    flex-direction: column;\n    gap: 100px;\n    width: 100%;\n    margin: 0 auto;\n  }\n\n  .scl--web-page-product-contact-card-wrapper {\n    width: 100%;\n    flex: none;\n    border: none;\n    border-top: none;\n    border-bottom: none;\n    padding: 0px;\n    min-height: 369px;\n    gap: 83px;\n  }\n\n  .scl--web-page-product-contact-card-wrapper:first-child {\n    border: none;\n  }\n\n  .scl--web-page-product-contact-card-wrapper:last-child {\n    border-bottom: none;\n  }\n\n  /* Override grid layout at 850px */\n  .scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper {\n    border: none;\n  }\n\n  .scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper:nth-child(odd),\n  .scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper:nth-child(even) {\n    border: none;\n  }\n\n  .scl--web-page-product-contact-card-wrapper  .scl--web-component-dynamic-contact-card-title{\n    font-size: 40px;\n  }\n    .scl--web-page-product-contact-card-wrapper  .scl--web-component-dynamic-contact-card-description{\n    font-size: 28px;\n  }\n  .scl--web-page-product-contact-card-wrapper .scl--web-component-dynamic-contact-card-button .scl--web-component-round-button-text{\n    font-size: 28px;\n\n  }\n  .scl--web-page-product-contact-card-wrapper .scl--web-component-dynamic-contact-card-button{\n    width: 380px;\n    height: 60px;\n    border-radius: 30px;\n  }\n\n  \n\n}\n\n@media screen and (max-width: 500px) {\n  .scl--web-page-product-contact-section {\n    padding-left: var(--global-mobile-padding-left);\n    padding-right: var(--global-mobile-padding-right);\n    height: auto;\n    max-height: none;\n    margin-top: 50px;\n  }\n\n  .scl--web-page-product-contact-top {\n    padding: 40px 0px;\n    gap: 20px;\n  }\n\n  .scl--web-page-product-contact-top-left {\n    gap: 74px;\n    max-width: 388px;\n  }\n\n  .scl--web-page-product-contact-title {\n    font-size: 60px;\n    line-height: 60px;\n    letter-spacing: -1.68px;\n  }\n\n  .scl--web-page-product-contact-description {\n    font-size: 24px;\n    line-height: 40px;\n    max-width: 411px;\n  }\n\n  .scl--web-page-product-contact-card-wrapper .scl--web-component-dynamic-contact-card-content {\n    width: 100%;\n    padding: 0 0;\n    gap: 40px;\n  }\n\n  .scl--web-page-product-contact-cards {\n    gap: 55px;\n  }\n\n  .scl--web-page-product-contact-card-wrapper {\n    border-left: none;\n    border-right: none;\n    padding: 20px 0px;\n    gap: 83px;\n    min-height: auto;\n  }\n\n  .scl--web-page-product-contact-card-wrapper:first-child {\n    border-left: none;\n  }\n\n  .scl--web-page-product-contact-card-wrapper .scl--web-component-dynamic-contact-card-title {\n    font-size: 55px;\n  }\n\n  .scl--web-page-product-contact-card-wrapper .scl--web-component-dynamic-contact-card-description {\n    font-size: 24px;\n    line-height: 150%;\n  }\n  .scl--web-page-product-contact-card-wrapper:last-child{\n    padding: 0;\n  }\n\n  /* Override grid layout at 500px */\n  .scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper {\n    border-left: none;\n    border-right: none;\n  }\n\n  .scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper:nth-child(odd),\n  .scl--web-page-product-contact-cards-grid .scl--web-page-product-contact-card-wrapper:nth-child(even) {\n    border-left: none;\n    border-right: none;\n  }\n    .scl--web-page-product-contact-card-wrapper .scl--web-component-dynamic-contact-card-button .scl--web-component-round-button-text{\n    font-size: 24px;\n\n  }\n  .scl--web-page-product-contact-card-wrapper .scl--web-component-dynamic-contact-card-button{\n    width: 100%;\n    height: 50px;\n    border-radius: 25px;\n  }\n\n  .scl--web-page-product-contact-section .scl--web-page-product-contact-section-lap{\n    width: 100%;\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
